module.exports = __webpack_public_path__ + "static/face-game-03a930cedd1b562a449029fa42540cc3.png";